/**
 * Article Page Slider Fix
 * Forces Flickity initialization on article/blog pages and prevents destruction
 */

(function() {
  'use strict';

  // Only run on article and blog pages
  const isArticlePage = document.body.classList.contains('template-article');
  const isBlogPage = document.body.classList.contains('template-blog');

  if (!isArticlePage && !isBlogPage) {
    console.log('[Article Slider Fix] Not an article/blog page, skipping...');
    return;
  }

  console.log('[Article Slider Fix] Initializing on article/blog page...');

  // Wait for DOM and Flickity library to be ready
  function initializeSlider() {
    // Check if Flickity is available
    if (typeof Flickity === 'undefined') {
      console.log('[Article Slider Fix] Flickity library not loaded yet, retrying...');
      setTimeout(initializeSlider, 100);
      return;
    }

    // Find the slider element
    const sliderElement = document.querySelector('[data-content][data-layout="slideshow"]');

    if (!sliderElement) {
      console.error('[Article Slider Fix] Slider element not found!');
      return;
    }

    // Check if already initialized
    if (sliderElement._flickity || sliderElement.flickity) {
      console.log('[Article Slider Fix] Flickity already initialized');
      const instance = sliderElement._flickity || sliderElement.flickity;

      // Protect the existing instance
      protectFlickityInstance(instance);
      return;
    }

    console.log('[Article Slider Fix] Initializing Flickity manually...');

    // Initialize Flickity with same settings as FeaturedCollection
    const flickity = new Flickity(sliderElement, {
      autoPlay: 0,
      accessibility: true,
      cellAlign: 'left',
      cellSelector: '.productgrid--item',
      groupCells: true,
      pageDots: true,
      contain: true,
      arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
    });

    // Add wrapper for proper overflow clipping (matching FeaturedCollection implementation)
    const viewport = sliderElement.querySelector('.flickity-viewport');
    const slider = sliderElement.querySelector('.flickity-slider');

    if (viewport && slider) {
      const sliderWrapper = document.createElement('div');
      sliderWrapper.classList.add('flickity-slider--wrapper');
      viewport.appendChild(sliderWrapper);
      sliderWrapper.appendChild(slider);

      // Override resize to handle wrapper
      const originalResize = flickity.resize.bind(flickity);
      flickity.resize = function() {
        viewport.style.height = '';
        originalResize();
      };
    }

    console.log('[Article Slider Fix] Flickity initialized successfully!');

    // Store reference
    sliderElement._flickity = flickity;
    sliderElement.flickity = flickity;

    // Protect this instance from being destroyed
    protectFlickityInstance(flickity);

    // Enhanced protection against section's breakpoint handler
    protectAgainstSectionDestruction(flickity, sliderElement);
  }

  function protectFlickityInstance(flickity) {
    const originalDestroy = flickity.destroy.bind(flickity);

    flickity.destroy = function() {
      const isArticle = document.body.classList.contains('template-article');
      const isBlog = document.body.classList.contains('template-blog');

      if (isArticle || isBlog) {
        console.warn('[Article Slider Fix] BLOCKED: Attempt to destroy Flickity on article/blog page!');
        return;
      }

      console.log('[Article Slider Fix] Allowing Flickity destruction on non-article page');
      originalDestroy();
    };

    console.log('[Article Slider Fix] Protection installed on Flickity instance');
  }

  function protectAgainstSectionDestruction(flickity, sliderElement) {
    console.log('[Article Slider Fix] Installing enhanced section destruction protection...');

    // Find the section element that contains this slider
    const section = sliderElement.closest('[data-section-type="dynamic-featured-collection"]');

    if (!section) {
      console.log('[Article Slider Fix] Section element not found, enhanced protection not needed');
      return;
    }

    // Monitor for attempts to nullify the instance via attribute changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-layout') {
          const isArticle = document.body.classList.contains('template-article');
          const isBlog = document.body.classList.contains('template-blog');

          if (isArticle || isBlog) {
            // Check if Flickity instance was nullified
            if (!sliderElement._flickity && !sliderElement.flickity) {
              console.warn('[Article Slider Fix] BLOCKED: Section tried to nullify Flickity instance via layout change!');
              console.log('[Article Slider Fix] Restoring Flickity instance references...');

              // Restore the instance references
              sliderElement._flickity = flickity;
              sliderElement.flickity = flickity;

              // Ensure layout stays as slideshow
              if (sliderElement.dataset.layout !== 'slideshow') {
                sliderElement.dataset.layout = 'slideshow';
                console.log('[Article Slider Fix] Restored layout attribute to "slideshow"');
              }
            }
          }
        }
      });
    });

    observer.observe(sliderElement, {
      attributes: true,
      attributeFilter: ['data-layout']
    });

    // Also use a periodic check as a backup safeguard
    setInterval(() => {
      const isArticle = document.body.classList.contains('template-article');
      const isBlog = document.body.classList.contains('template-blog');

      if ((isArticle || isBlog) && (!sliderElement._flickity || !sliderElement.flickity)) {
        console.warn('[Article Slider Fix] DETECTED: Flickity instance was nullified! Restoring...');
        sliderElement._flickity = flickity;
        sliderElement.flickity = flickity;

        if (sliderElement.dataset.layout !== 'slideshow') {
          sliderElement.dataset.layout = 'slideshow';
        }
      }
    }, 1000); // Check every second

    console.log('[Article Slider Fix] Enhanced protection fully installed (MutationObserver + Periodic Check)');
  }

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSlider);
  } else {
    // DOM already loaded
    setTimeout(initializeSlider, 500);
  }

})();
